"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 8a7.962 7.962 0 0 1-1.897 5.161l-.707-.707A6.963 6.963 0 0 0 15 8c0-3.86-3.14-7-7-7-3.859 0-7 3.14-7 7s3.141 7 7 7a6.965 6.965 0 0 0 4.697-1.824l.707.706A7.964 7.964 0 0 1 8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8c4.412 0 8 3.589 8 8ZM8 4.5C6.07 4.5 4.5 6.07 4.5 8s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5S9.93 4.5 8 4.5Zm0 8A4.505 4.505 0 0 1 3.5 8c0-2.481 2.02-4.5 4.5-4.5 2.481 0 4.5 2.019 4.5 4.5 0 2.48-2.019 4.5-4.5 4.5Zm1.315-4.502a1.25 1.25 0 1 1-2.501-.001 1.25 1.25 0 0 1 2.5 0Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22.875C6.004 22.875 1.125 17.996 1.125 12S6.004 1.125 12 1.125 22.875 6.004 22.875 12c0 2.796-1.07 5.34-2.81 7.269l.795.796C22.804 17.93 24 15.106 24 12c0-6.617-5.384-12-12-12C5.383 0 0 5.383 0 12c0 6.616 5.383 12 12 12 3.107 0 5.932-1.196 8.065-3.14l-.795-.795a10.822 10.822 0 0 1-7.27 2.81Zm0-16.313a5.443 5.443 0 0 0-5.438 5.437A5.443 5.443 0 0 0 12 17.438 5.443 5.443 0 0 0 17.438 12 5.443 5.443 0 0 0 12 6.562Zm0 12a6.57 6.57 0 0 1-6.563-6.563A6.57 6.57 0 0 1 12 5.437a6.57 6.57 0 0 1 6.563 6.562A6.57 6.57 0 0 1 12 18.563Zm.175-4.688a1.875 1.875 0 1 0 0-3.749 1.875 1.875 0 0 0 0 3.75Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 30.5C8.005 30.5 1.5 23.995 1.5 16S8.005 1.5 16 1.5 30.5 8.005 30.5 16c0 3.728-1.426 7.121-3.747 9.692l1.06 1.061C30.405 23.908 32 20.142 32 16c0-8.822-7.178-16-16-16S0 7.178 0 16s7.178 16 16 16c4.142 0 7.909-1.595 10.753-4.187l-1.06-1.06C23.121 29.073 19.728 30.5 16 30.5Zm0-21.75c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S19.998 8.75 16 8.75Zm0 16c-4.825 0-8.75-3.925-8.75-8.75S11.175 7.25 16 7.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75Zm.233-6.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24 46.125C11.8 46.125 1.875 36.2 1.875 24S11.8 1.875 24 1.875 46.125 11.8 46.125 24a22.027 22.027 0 0 1-5.545 14.626l1.343 1.312C45.7 35.696 48 30.111 48 24 48 10.766 37.234 0 24 0S0 10.766 0 24s10.766 24 24 24c6.448 0 12.306-2.561 16.622-6.713l-1.34-1.31c-3.976 3.804-9.36 6.148-15.282 6.148Zm0-33.186c-6.1 0-11.063 4.963-11.063 11.063 0 6.1 4.963 11.062 11.063 11.062 6.1 0 11.063-4.963 11.063-11.063 0-6.1-4.963-11.062-11.063-11.062Zm0 24c-7.134 0-12.938-5.803-12.938-12.938 0-7.134 5.804-12.937 12.938-12.937s12.938 5.803 12.938 12.938c0 7.134-5.804 12.937-12.938 12.937Zm.256-9.188a3.75 3.75 0 1 0-.001-7.5 3.75 3.75 0 0 0 0 7.5Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32 61.5C15.734 61.5 2.5 48.266 2.5 32S15.734 2.5 32 2.5 61.5 15.734 61.5 32c0 7.471-2.797 14.298-7.393 19.501l1.791 1.749C60.933 47.594 64 40.15 64 32 64 14.355 49.645 0 32 0S0 14.355 0 32s14.355 32 32 32c8.598 0 16.408-3.415 22.163-8.951l-1.788-1.746C47.074 58.375 39.897 61.5 32 61.5Zm0-44.248c-8.133 0-14.75 6.617-14.75 14.75s6.617 14.75 14.75 14.75 14.75-6.617 14.75-14.75-6.617-14.75-14.75-14.75Zm0 32c-9.512 0-17.25-7.738-17.25-17.25s7.738-17.25 17.25-17.25 17.25 7.738 17.25 17.25-7.738 17.25-17.25 17.25Zm.34-12.25a5 5 0 1 0 0-10.001 5 5 0 0 0 0 10.001Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconTarget = function IconTarget(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Target' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Target"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconTarget.sizes = [16, 24, 32, 48, 64];
IconTarget.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconTarget;
exports.default = _default;